// extracted by mini-css-extract-plugin
module.exports = {"RegisterForm":"styles_RegisterForm__aS3ZN"};